import ArticleCard from '../../../components/feature/ArticleCard';
import { articles } from '../../../mocks/articles';

export default function LatestArchive() {
  const list = articles.slice(0, 8);
  return (
    <section className="bg-background-100">
      <div className="container-x py-12 md:py-16">
        <div className="flex items-end justify-between">
          <div>
            <p className="text-sm font-medium tracking-wide text-secondary-700">LATEST ARCHIVE</p>
            <h2 className="mt-1 font-display text-2xl font-black text-foreground-900 md:text-3xl">
              最新入档 · 全网热搜
            </h2>
          </div>
          <span className="hidden text-sm text-foreground-500 sm:inline">共收录 {articles.length} 篇当期档案</span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((a) => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </div>
      </div>
    </section>
  );
}